/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUserInfo,
    JsonSerieUserInfoFromJSON,
    JsonSerieUserInfoFromJSONTyped,
    JsonSerieUserInfoToJSON,
} from './JsonSerieUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonSerieUserInfo
 */
export interface ApiResultOfListOfJsonSerieUserInfo {
    /**
     * 
     * @type {Array<JsonSerieUserInfo>}
     * @memberof ApiResultOfListOfJsonSerieUserInfo
     */
    data?: Array<JsonSerieUserInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonSerieUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUserInfo
     */
    result?: ApiResultOfListOfJsonSerieUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonSerieUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonSerieUserInfoFromJSON(json: any): ApiResultOfListOfJsonSerieUserInfo {
    return ApiResultOfListOfJsonSerieUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonSerieUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonSerieUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonSerieUserInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonSerieUserInfoToJSON(value?: ApiResultOfListOfJsonSerieUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonSerieUserInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

